const initialState = {
  hasHydrated: false,
};

const hydrationSlice = (set) => ({
  ...initialState,
  setHasHydrated: (state) => set({ hasHydrated: state }),
});

export default hydrationSlice;
